<template>
  <div class="yxtbiz-mengniu-month-audit">
    <div class="standard-size-16 color-gray-10">
      <div class="mb32 font-bolder">
        计划详情
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">年度：</span>
            <div class="yxtbiz-mengniu-month-audit_ellipsis">
              {{ projectInfo.year || '--' }}
            </div>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">培训月份：</span>
            <div class="yxtbiz-mengniu-month-audit_ellipsis">
              {{ `${projectInfo.month}月` || '--' }}
            </div>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">计划级别：</span>
            <yxtf-tag size="small" v-if="projectInfo.plan_level"
              >{{ projectInfo.plan_level }}级</yxtf-tag
            >
            <div v-else>--</div>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">所属组织：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="projectInfo.dept_name"
              placement="top"
            >
              <div class="yxtbiz-mengniu-month-audit_ellipsis">
                {{ projectInfo.dept_name || '--' }}
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">专业线：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="projectInfo.professional_line_name"
              placement="top"
            >
              <div class="yxtbiz-mengniu-month-audit_ellipsis">
                {{ projectInfo.professional_line_name || '--' }}
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">负责人：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="projectInfo.owner_name"
              placement="top"
            >
              <div class="yxtbiz-mengniu-month-audit_ellipsis">
                {{ projectInfo.owner_name || '--' }}
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row
          type="flex"
          class="mv24 font-normal font-size-14"
          v-if="projectInfo.change_type_names"
        >
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">对比变化：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="projectInfo.change_type_names"
              placement="top"
            >
              <div class="yxtbiz-mengniu-month-audit_ellipsis">
                {{ projectInfo.change_type_names || '--' }}
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row
          type="flex"
          class="mv24 font-normal font-size-14"
          v-if="projectInfo.change_reason"
        >
          <yxtf-col :span="24" class="nowrap mh2 flex-center">
            <span class="color-gray-7">变化原因描述：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="projectInfo.change_reason"
              placement="top"
            >
              <div class="yxtbiz-mengniu-month-audit_ellipsis">
                {{ projectInfo.change_reason || '--' }}
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxt-row class="yxtbiz-project-audit__row" :gutter="32">
          <yxt-col :span="24">
            <yxt-button @click="goProjectDetail" type="text"
              >查看详情</yxt-button
            >
          </yxt-col>
        </yxt-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getProjectInfo, getProjectChangelogInfo } from './service';

export default {
  name: 'YxtbizMengniuMonthAudit',
  props: {
    // 审核中心给的赋能计划id
    auditId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      projectInfo: {} // 项目的详情
    };
  },
  computed: {
    planId() {
      return this.auditId.includes('RECORD')
        ? this.auditId.replace('RECORD', '')
        : this.auditId;
    },
    orgId() {
      return localStorage.getItem('orgId');
    },
    isRecord() {
      return this.auditId.includes('RECORD');
    }
  },
  watch: {
    auditId: {
      immediate: true,
      handler() {
        this.getProject();
      }
    }
  },
  methods: {
    // 获取项目的详情
    getProject() {
      let data = {
        orgId: this.orgId, // 机构id
        id: this.planId // 计划id
      };
      let ajaxFunc = this.isRecord ? getProjectChangelogInfo : getProjectInfo;
      ajaxFunc(data).then(res => {
        if (res.code === 0) {
          let { basic } = res.data;
          this.projectInfo = basic;
        }
      });
    },
    goProjectDetail() {
      let subUrl = this.isRecord
        ? '/mix/mengniu/#/month/empowerment/plan/change/record/detail?recordId='
        : '/mix/mengniu/#/month/empowerment/plan/detail?id=';
      const url = `${window.location.origin}${subUrl}${this.planId}`;
      window.open(url);
    }
  }
};
</script>
